import {completeLoginHandoff} from './login-recovery';
import cookie from 'react-cookies';
import {endPurchaseCountdown} from './purchase-countdown-session';

export default class AndroidComm {
    static sendSession(session) {
        if (session && session.userId && session.accessToken){
            const sent = this.sendRawMessage(session);
            if (sent) completeLoginHandoff(session);
            return sent;
        }else{
            this.sendRawMessage({
                success: false,
                message: "Internal Server Error"
            });
        }
    }

    static sendPurchaseResult(result) {
        if(result.status === 200) {
            this.sendRawMessage(result.data);
        } else {
            this.sendRawMessage({
                success: false,
                message: result.data.message
            });
        }
    }

    static sendRawMessage(message) {
        if (!cookie.load("jggsdk_sendRawMessage")){

            cookie.save("jggsdk_sendRawMessage", new Date().getTime() + 2000, {
                path: "/",
                expires: new Date(new Date().getTime() + 2000) 
            });

        let platform_operation = cookie.load('_platform_operation');
        if (!platform_operation){
            platform_operation = "pay";
        }
        if ((platform_operation === "login") || (platform_operation === "pay")){
            let operation = platform_operation + "_complete";
            endPurchaseCountdown();
            this.postH5Message(operation, message);
        }else{
            const path = `jggsdk:${JSON.stringify(message)}`;

            endPurchaseCountdown();
            window.open(path, "_self");
        }
        return true;
        }else{
            return false;
        }
    }

    static postH5Message(operation, jsondata){
        const data={
            "operation": operation,
            "params": {}
          };
        data.params.jggsdk = jsondata;  

        window.top.postMessage(data,'*');
    }
}

export class TransactionResult {
    success;
    transactionId;
    status;
    message;

    constructor(success, transactionId, status, message) {
        this.success = success;
        this.transactionId = transactionId;
        this.status = status;
        this.message = message;
    }
}